// extracted by mini-css-extract-plugin
module.exports = {"bg":"styles_bg__3a_jq","color-love":"styles_color-love__hve_i"};